<template>
  <div>
    <div class="yuliang" ref="yuliang">
      <div class="select">
        <span class="desc">起止日期:</span>
        <div class="block" style="display: inline-block;">
          <el-date-picker
            v-model="beginDate"
            type="date"
            :picker-options="Global.pickerOptionsStart(endDate)"
            value-format="yyyy-MM-dd"
            :clearable="false"
            :editable="false"
            placeholder="选择日期"
          ></el-date-picker>
          <span class="desc">至</span>
          <el-date-picker
            v-model="endDate"
            type="date"
            :picker-options="Global.pickerOptionsEnd(beginDate)"
            value-format="yyyy-MM-dd"
            :clearable="false"
            :editable="false"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
        <span @click="dayselect" id="select">查询</span>
        <span @click="exportdata" id="export">
          <span class="export-icon"></span>导出
        </span>
      </div>
      <div class="raintable" ref="rttable">
        <ux-grid
          ref="plTable"
          highlight-current-row
          v-loading="loading"
          :max-height="height"
          :data="tdata"
          border
          v-if="tableShow"
          style="width: 100%;"
          :sort-config="{defaultSort:{field: 'ljyl',order: 'desc'}}"
        >
          <ux-table-column
            fixed="left"
            type="index"
            width="60"
            title="序号"
            align="center"
            header-align="center"
          ></ux-table-column>
          <ux-table-column fixed="left" field="addvnm" title="乡镇" sortable width="120" align="center"></ux-table-column>
          <ux-table-column fixed="left" field="stnm" title="站名" sortable width="150" align="center">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row.stnm + ' ' + (scope.row.stcd?scope.row.stcd:'')" placement="top" class="item" popper-class="hiddenOverflow">
                <span style="cursor:pointer!important;" >{{ scope.row.stationName }}</span>
              </el-tooltip>
            </template>
          </ux-table-column>
          <ux-table-column fixed="left" field="ljyl" sortable title="累计" width="90" align="center" header-align="center" :sort-method="sortByljyl">
            <template slot-scope="scope">
              <span>{{formatTableCellValue(scope.row['oldljyl'])}}</span>
            </template>
          </ux-table-column>
          <ux-table-column
            min-width = "90"
            v-for="(item,index) in thedate"
            :key="index"
            :field="item"
            :title="item"
            sortable
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <span>{{formatTableCellValue(scope.row['old'+item])}}</span>
            </template>
          </ux-table-column>
        </ux-grid>
      </div>
    </div>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
export default {
  name: 'MonitoringCenter',
  data () {
    return {
      loading: true,
      height: 10,
      // choosed: 0,
      sID: '22',
      sTID: '',
      beginDate: '',
      endDate: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      datenum: '',
      thedate: [],
      dialogVisible: false,
      thestation: '',
      tableShow: true
    }
  },
  computed: {},
  methods: {
    sortByljyl (a, b) {
      if (a.ljyl !== undefined) {
        return a.ljyl - b.ljyl
      } else {
        return -1
      }
    },
    stationchart (data) {
      this.thestation = data
      this.dialogVisible = true
    },
    tabledata () {
      this.loading = true
      this.$store
        .dispatch(monitorTypes.GET_DAILY_RAINFALL_INFO, {
          sID: this.sID,
          sTID: this.sTID,
          beginDate: this.beginDate,
          endDate: this.endDate,
          mainStation: true
        })
        .then(data => {
          this.tdata = []
          this.tableShow = false
          this.$nextTick(() => { // 解决排序无效问题
            this.tableShow = true
            this.$set(this, 'tdata', data.rows)
            this.tdata.forEach(element => {
              element.data.forEach(item => {
                let date = ''
                if (item.date === '累计雨量') {
                  date = 'ljyl'
                } else {
                  date = item.date.slice(5)
                }
                element[date] = this.getTableCellValue(item.value_Str)
                element['old' + date] = item.value_Str
              })
            })
          })
          // this.$refs.plTable.reloadData(this.tdata) // umy-ui列表加载优化
          this.loading = false
        })
    },
    getTableCellValue: function (val) {
      let result = 0
      if (val !== undefined && val !== '') {
        result = Number(val)
      }
      return result
    },
    formatTableCellValue (val) {
      let result = val
      if (val === undefined || val === '') {
        result = '-'
      }
      return result
    },
    dayselect: function () {
      this.loading = true
      this.thedate = this.getDates(this.beginDate, this.endDate, 0)
      this.tabledata()
    },
    initSearchDate: function () {
      var date = new Date()
      let formatDate = this.$options.filters['formatDate']
      this.endDate = `${formatDate(date, 'yyyy-MM-dd')}`
      this.beginDate = `${formatDate(new Date(date.getTime() - 1000 * 60 * 60 * 24 * 14), 'yyyy-MM-dd')}`
    },
    exportdata () {
      this.$store
        .dispatch(monitorTypes.EXPORT_RAINSTATIS_DAILY, {
          sID: this.sID,
          sTID: this.sTID,
          beginDate: this.beginDate,
          endDate: this.endDate,
          mainStation: true
        })
        .then(data => {
          window.location.href = this.Global.basePath + data.data
          // window.location.href
        })
    }, // startDate: 计划开始时间； endDate：计划结束时间；dayLength：每隔几天，0-代表每天，1-代表日期间隔一天
    getDates: function (startDate, endDate, dayLength) {
      let dates = []
      dates.push(startDate.slice(5))
      while (true) {
        var getDate = this.getTargetDate(startDate, dayLength)
        startDate = getDate
        if (getDate <= endDate) {
          dates.push(getDate.slice(5))
        } else {
          break
        }
      }
      return dates
    },
    // startDate: 开始时间；dayLength：每隔几天，0-代表获取每天，1-代表日期间隔一天
    getTargetDate: function (date, dayLength) {
      dayLength = dayLength + 1
      let tempDate = new Date(date)
      tempDate.setDate(tempDate.getDate() + dayLength)
      let year = tempDate.getFullYear()
      let month =
        tempDate.getMonth() + 1 < 10
          ? '0' + (tempDate.getMonth() + 1)
          : tempDate.getMonth() + 1
      let day =
        tempDate.getDate() < 10 ? '0' + tempDate.getDate() : tempDate.getDate()
      return year + '-' + month + '-' + day
    }
  },
  created () {
    this.initSearchDate()
    this.dayselect()
  },
  mounted () {
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45 + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height =
        this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style scoped>
.yuliang >>> .el-date-editor.el-input,
.yuliang >>> .el-date-editor.el-input__inner {
  width: 150px;
}
</style>
<style lang="less" scoped>
  /* 优化表格样式 */
 .plTableBox /deep/ .elx-table{
  text-align: center !important;
  font-family: Microsoft YaHei UI !important;
  font-size: 15px !important;
  color: #666 !important;
  .elx-table--header-wrapper thead tr {
    background: #F5F7FA !important;
  }
}
/deep/ .elx-table tr:nth-child(even) {
  background: #eaf1fa !important;
}
</style>
